<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-note2 text-white"></i></div>
        <div>
          Reports
          <div class="page-title-subheading">Filterable production log by date, product and operator.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-2 card">
    <div class="card-body">
      <div class="form-row align-items-end">
        <div class="col-auto form-group">
          <label>Date</label>
          <input class="form-control" type="date" [(ngModel)]="filters.date" />
        </div>
        <div class="col-auto form-group">
          <label>Product</label>
          <select class="form-select" [(ngModel)]="filters.productId">
            <option value="">All Products</option>
            <option *ngFor="let product of products" [value]="product._id">{{ product.name }}</option>
          </select>
        </div>
        <div class="col-auto form-group">
          <label>Operator</label>
          <select class="form-select" [(ngModel)]="filters.operatorId">
            <option value="">All Operators</option>
            <option *ngFor="let operator of operators" [value]="operator._id">{{ operator.name }}</option>
          </select>
        </div>
        <div class="col-auto form-group">
          <button class="btn btn-primary" (click)="runReport()">Run Report</button>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-2 card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <span class="spinner-border text-primary"></span>
      </div>
      <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
    </div>
  </div>
</div>
